import DragScroll from "./components/DragScroll";
import { Copy } from "./modules/Copy";
import Catalog from "./components/Catalog/Catalog";
import { ProductGallery } from "./components/Catalog/ProductGallery";
import QuickCart from "./components/QuickCart";

$(document).ready(() => {
    $('[data-entity="mainslider"]').on('init', () => {
        document.querySelectorAll('[data-entity="mainslider"] [data-entity="copy"]').forEach(copyNode => {
            new Copy(copyNode);
        });
    });

    $('[data-entity="mainslider"]').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false,

        // we can also prevent the slider from flickering at the cost of animation smoothness by disabling CSS transforms
        // https://github.com/kenwheeler/slick/issues/1890
        // https://github.com/kenwheeler/slick/issues/1961
        // useTransform: false,
        // easing: 'swing'
    });

    [...document.querySelectorAll('.l-chips__list')]
        .forEach(rootNode => {
            new DragScroll({ rootNode });
        });


    // Catalog Gallery
    new ProductGallery(document.querySelector('.js-products'));

    // Быстрое добавление в корзину в списках
    new QuickCart();

    $(document).on('click', '.js-products .js-section_product a[href]', function() {
        let productId = $(this).closest('.js-section_product').data('product');
        if (productId) {
            sessionStorage.setItem('lastViewedProduct', productId);
        }
    });

    Catalog.scrollToLastViewedProduct();
});

if (!window.loadNextPage) {
    window.loadNextPage = function(event) {
        event.preventDefault();
    
        let $this = $(event.target),
            replaceable = $this.parent(),
            page = $this.data('url');
    
        $this.addClass('btn-progress').prop('disabled', true);
    
        Catalog.load(page, {}, function (result) {
            if (result !== false) {
                replaceable.replaceWith(result.find('.js-products').html());
    
                if (typeof BX !== 'undefined' && BX.ajax?.history) {
                    let urlObj = new URL(page, window.location.href);
                    urlObj.searchParams.delete('bId');
                    let url = urlObj.pathname + urlObj.search + urlObj.hash;
                    
                    BX.ajax.history.put({ url }, url);
                }
    
                $('.js-products').trigger('mario.catalog.reloaded');
            } else {
                $this.removeClass('btn-progress').prop('disabled', false);
            }
        });
    };
}